<script lang="ts" setup>
    const { blok } = defineProps<{
        blok: LoyaltyPointBadgeStoryblok;
    }>();
</script>

<template>
    <div
        v-editable="blok"
        class="badge"
        :class="`--color-${blok.color}`"
    >
        <p class="points">{{ blok.points }}</p>
        <p>{{ $t('account.bonus.unit') }}</p>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/pta-family/surveys/loyalty-point-badge.scss';
</style>
